import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BookOpen } from "lucide-react";

const VERSES = [
  { text: "For I know the plans I have for you, declares the Lord, plans to prosper you and not to harm you, plans to give you hope and a future.", ref: "Jeremiah 29:11" },
  { text: "I can do all things through Christ who strengthens me.", ref: "Philippians 4:13" },
  { text: "The Lord is my shepherd; I shall not want.", ref: "Psalm 23:1" },
  { text: "Trust in the Lord with all your heart and lean not on your own understanding.", ref: "Proverbs 3:5" },
  { text: "But they that wait upon the Lord shall renew their strength; they shall mount up with wings as eagles.", ref: "Isaiah 40:31" },
  { text: "Be strong and of a good courage; be not afraid, neither be thou dismayed: for the Lord thy God is with thee.", ref: "Joshua 1:9" },
  { text: "And we know that all things work together for good to them that love God.", ref: "Romans 8:28" },
  { text: "The joy of the Lord is your strength.", ref: "Nehemiah 8:10" },
  { text: "Jesus Christ, the same yesterday, today, and forever.", ref: "Hebrews 13:8" },
  { text: "No weapon formed against you shall prosper.", ref: "Isaiah 54:17" },
  { text: "Delight thyself also in the Lord; and he shall give thee the desires of thine heart.", ref: "Psalm 37:4" },
  { text: "For God has not given us a spirit of fear, but of power, and of love, and of a sound mind.", ref: "2 Timothy 1:7" },
];

function getDailyVerse() {
  const today = new Date();
  const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / (1000 * 60 * 60 * 24));
  return VERSES[dayOfYear % VERSES.length];
}

export default function BibleVerse() {
  const [verse, setVerse] = useState(getDailyVerse());

  return (
    <section data-testid="bible-verse-section" className="py-12 px-6 bg-slate-50 border-y border-slate-100">
      <div className="max-w-3xl mx-auto">
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
        >
          <div className="flex items-center justify-center gap-2 mb-4">
            <BookOpen className="w-4 h-4 text-navy/50" />
            <span className="font-body text-navy/50 text-xs uppercase tracking-[0.15em] font-bold">Verse of the Day</span>
          </div>
          <p className="font-body text-navy/80 text-base sm:text-lg italic leading-relaxed mb-3">
            "{verse.text}"
          </p>
          <p className="font-heading font-bold text-crimson text-sm">
            &mdash; {verse.ref}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
